<template>
  <div>
    <b-card>
      <h4 class="font-weight-bolder">Security & Compliance Reports</h4>
      <b-row class="mt-3">
        <b-col md="6">
          <h5 class="font-weight-bolder">Security Reports</h5>
          <div>
            <b-card
              border-variant="secondary"
              body-class="p-0"
              class="w-100 mb-2"
              style="padding: 8px"
            >
              <div class="d-flex align-items-center justify-content-between">
                <div>
                  <p class="mb-0 font-weight-bolder">
                    Vulnerability Assessment
                  </p>
                  <span class="small text-muted">
                    Weekly security vulnerability scan
                  </span>
                </div>
                <b-button
                  size="sm"
                  variant="outline-secondary"
                  class="font-weight-bolder text-body"
                >
                  <feather-icon icon="DownloadIcon" /> Download
                </b-button>
              </div>
            </b-card>
            <b-card
              border-variant="secondary"
              body-class="p-0"
              class="w-100 mb-2"
              style="padding: 8px"
            >
              <div class="d-flex align-items-center justify-content-between">
                <div>
                  <p class="mb-0 font-weight-bolder">Penetration Test Report</p>
                  <span class="small text-muted">
                    Quarterly external security assessment
                  </span>
                </div>
                <b-button
                  size="sm"
                  variant="outline-secondary"
                  class="font-weight-bolder text-body"
                >
                  <feather-icon icon="DownloadIcon" /> Download
                </b-button>
              </div>
            </b-card>
            <b-card
              border-variant="secondary"
              body-class="p-0"
              class="w-100 mb-2"
              style="padding: 8px"
            >
              <div class="d-flex align-items-center justify-content-between">
                <div>
                  <p class="mb-0 font-weight-bolder">Incident Response Log</p>
                  <span class="small text-muted">
                    Security incident tracking and response
                  </span>
                </div>
                <b-button
                  size="sm"
                  variant="outline-secondary"
                  class="font-weight-bolder text-body"
                >
                  <feather-icon icon="DownloadIcon" /> Download
                </b-button>
              </div>
            </b-card>
          </div>
        </b-col>

        <!-- Compliance Reports -->
        <b-col md="6">
          <h5 class="font-weight-bolder">Compliance Reports</h5>
          <div>
            <b-card
              border-variant="secondary"
              body-class="p-0"
              class="w-100 mb-2"
              style="padding: 8px"
            >
              <div class="d-flex align-items-center justify-content-between">
                <div>
                  <p class="mb-0 font-weight-bolder">
                    AUSTRAC Compliance Report
                  </p>
                  <span class="small text-muted">
                    Monthly AML/CTF compliance summary
                  </span>
                </div>
                <b-button
                  size="sm"
                  variant="outline-secondary"
                  class="font-weight-bolder text-body"
                >
                  <feather-icon icon="DownloadIcon" /> Download
                </b-button>
              </div>
            </b-card>

            <b-card
              border-variant="secondary"
              body-class="p-0"
              class="w-100 mb-2"
              style="padding: 8px"
            >
              <div class="d-flex align-items-center justify-content-between">
                <div>
                  <p class="mb-0 font-weight-bolder">PCI DSS Audit Report</p>
                  <span class="small text-muted">
                    Annual payment security compliance
                  </span>
                </div>
                <b-button
                  size="sm"
                  variant="outline-secondary"
                  class="font-weight-bolder text-body"
                >
                  <feather-icon icon="DownloadIcon" /> Download
                </b-button>
              </div>
            </b-card>

            <b-card
              border-variant="secondary"
              body-class="p-0"
              class="w-100 mb-2"
              style="padding: 8px"
            >
              <div class="d-flex align-items-center justify-content-between">
                <div>
                  <p class="mb-0 font-weight-bolder">
                    Privacy Impact Assessment
                  </p>
                  <span class="small text-muted">
                    Data privacy compliance evaluation
                  </span>
                </div>
                <b-button
                  size="sm"
                  variant="outline-secondary"
                  class="font-weight-bolder text-body"
                >
                  <feather-icon icon="DownloadIcon" /> Download
                </b-button>
              </div>
            </b-card>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<script>
import {
  BCard,
  BButton,
  BListGroup,
  BListGroupItem,
  BCol,
  BRow,
} from "bootstrap-vue";
export default {
  components: {
    BCard,
    BButton,
    BListGroup,
    BListGroupItem,
    BCol,
    BRow,
  },
};
</script>
